import React from 'react';
import './index.less';
var Loading = function Loading() {
  return /*#__PURE__*/React.createElement("div", {
    className: 'fx-router-loading'
  }, /*#__PURE__*/React.createElement("span", {
    className: "fx-spin-dot fx-spin-dot-spin"
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null)));
};
export default Loading;